import { useState } from "react";
import { Play } from "lucide-react";

// ============================================================
// PASTE YOUR VIDEO URL HERE (mp4, YouTube or Vimeo link)
// Example: const VIDEO_URL = "https://youtu.be/your-video-id";
// ============================================================
const VIDEO_URL = "";

const getEmbedUrl = (url) => {
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]{6,})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}?rel=0`;
  const vimeo = url.match(/vimeo\.com\/(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
  return null;
};

export const VideoPlayer = () => {
  const [playing, setPlaying] = useState(false);
  const embedUrl = VIDEO_URL ? getEmbedUrl(VIDEO_URL) : null;
  const isFile = VIDEO_URL && !embedUrl;

  return (
    <div
      data-testid="video-frame"
      className="relative w-full overflow-hidden rounded-xl border border-lime/40 bg-[#111110] shadow-[0_20px_60px_-15px_rgba(205,251,45,0.25)]"
      style={{ aspectRatio: "16 / 9" }}
    >
      {!VIDEO_URL && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-[radial-gradient(ellipse_at_center,#1a1a17_0%,#0b0b09_75%)]">
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-lime text-ink transition-transform duration-300 hover:scale-105">
            <Play className="ml-1 h-7 w-7 fill-current" />
          </span>
          <span className="font-condensed text-xs uppercase tracking-[0.3em] text-cream/60">
            Video preview coming soon
          </span>
        </div>
      )}

      {embedUrl && !playing && (
        <button
          data-testid="video-play-button"
          onClick={() => setPlaying(true)}
          className="absolute inset-0 flex items-center justify-center bg-[radial-gradient(ellipse_at_center,#1a1a17_0%,#0b0b09_75%)]"
          aria-label="Play video"
        >
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-lime text-ink transition-transform duration-300 hover:scale-110">
            <Play className="ml-1 h-7 w-7 fill-current" />
          </span>
        </button>
      )}

      {embedUrl && playing && (
        <iframe
          data-testid="video-embed"
          src={`${embedUrl}${embedUrl.includes("?") ? "&" : "?"}autoplay=1`}
          title="ALIGNMENT — Human Design for Business"
          className="absolute inset-0 h-full w-full"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      )}

      {isFile && (
        <video
          data-testid="video-element"
          src={VIDEO_URL}
          controls
          playsInline
          className="absolute inset-0 h-full w-full object-cover"
        />
      )}
    </div>
  );
};
